import "core-js/stable";
import "regenerator-runtime/runtime";
import './add-to-basket/';
import './checkout'; 
import './dropdown-menu';
import './faqs';
import './footer';
import './header';
import './in-view';
import './language-select';
import './mini-cart';
import './mobile-menu'; 
import './pdp-benefits';
import './pdp-featured';
//import './plp';
import './product-carousel';
import './search';
import './testimonials';
import './viewport-height';
import './mobile-content-carousels';
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

//add simple support for background images:
document.addEventListener('lazybeforeunveil', function(e){
    var bg = e.target.getAttribute('data-bg');
    if(bg){
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
});